export const FETCH_TANENTS = "fetch_tanent";
export const FETCH_TANENTS_SUCCESS = "fetch_tanents_success";
export const TANENT_NAME = "tanent_name";
export const TANENT_EMAIL = "tanent_email";
export const TANENT_DESCRIPTION = "tanent_description";
export const TANENT_CREATE = "tanent_create";
export const TANENT_ACTION_SUCCESS = "tanent_action_success";
export const TANENT_STATUS_CHANGE_DIALOG_BOX = "tanent_status_change_dialog_box";
export const TANENT_CHANGE_STATUS_ID = "tanent_change_status_id";
export const TANENT_STATUS_CHANGE = "tanent_status_change";
